<template>
  <v-app id="inspire">
    <v-content class="login-frame">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5">
              <ValidationObserver v-slot="{ invalid }">
                <v-card-text class="mt-10">
                  <v-form class="mt-5">
                    <!-- Email -->
                    <VTextFieldWithValidation
                      rules="required"
                      v-model="user.email"
                      label="E-mail"
                      @input="user.email = user.email.toLowerCase()"
                    />

                    <!-- Password -->
                    <VTextFieldWithValidation
                      rules="required"
                      v-model="user.password"
                      label="Contraseña"
                      :type="showInput ? 'text' : 'password'"
                      :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'"
                      counter
                      autocomplete="off"
                      @keyup.enter="submit"
                      @click:append="showInput = !showInput"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    to="/recuperar-contraseña"
                    color="#9ccc3c"
                    text
                    dark
                    style="text-transform:none;font-family: 'Kaleko', sans-serif;"
                    >Olvide mi contraseña</v-btn
                  >
                  <v-spacer />
                  <v-btn
                    color="#9ccc3c"
                    @click="submit"
                    :disabled="invalid"
                    style="text-transform:none;color:#fff;font-family: 'Kaleko', sans-serif;"
                    >Ingresar</v-btn
                  >
                </v-card-actions>
                <v-spacer />
              </ValidationObserver>
            </v-card>
            <div class="text-center mt-5">
              <p style="color:#fff;font-family: 'Kaleko', sans-serif;">
                ¿Aún no tienes cuenta?
              </p>
              <v-btn
                x-large
                style="text-transform:none; color:#fff;font-family: 'Kaleko', sans-serif; "
                color="#9ccc3c"
                to="/registro"
                >Regístrate</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}
        <v-btn
          style="text-transform:none;"
          color="#9ccc3c"
          text
          @click="snackbar = false"
          >Ok</v-btn
        >
      </v-snackbar>
      <v-snackbar
        v-model="snackbarEmail"
        color="success"
        :multi-line="true"
        :top="true"
        :right="true"
        :timeout="0"
      >
        {{ this.$store.state.auth.EmailPassRecuperationMsg }}
        {{ this.$store.state.auth.signedMssg }}
        <v-btn style="text-transform:none;" color="#fff" text @click="GotIt"
          >Ok</v-btn
        >
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  props: {
    source: String,
  },
  computed: {
    ...mapGetters("auth", { isObipetsAdmin: "isObipetsAdmin" }),
  },
  mounted() {
    if (
      this.$store.state.auth.signed == true ||
      this.$store.state.auth.EmailPassRecuperation == true
    ) {
      this.snackbarEmail = true;
    }
  },
  data() {
    return {
      snackbarEmail: false,
      showInput: false,
      snackbar: false,
      snackbarText: "",
      user: {
        email: "",
        password: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    };
  },
  methods: {
    ...mapActions("auth", { getToken: "getToken" }),
    ...mapMutations({ setSnackbar: "setSnackbar" }),
    GotIt() {
      this.snackbarEmail = false;
      this.$store.state.auth.signed = false;
      this.$store.state.auth.EmailPassRecuperation = false;
      this.$store.state.auth.signedMssg = null;
      this.$store.state.auth.EmailPassRecuperationMsg = null;
    },
    submit() {
      this.getToken(this.user)
        .then(() => {
          if (this.isObipetsAdmin) {
            this.$router
              .push({
                name: "adminDash",
              })
              .catch(() => {});
          } else {
            this.$router
              .push({
                name: "userDash",
              })
              .catch(() => {});
          }
        })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarText = `Hubo un error: ${err.detail}`;
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
